module.exports = __webpack_public_path__ + "static/planted-vimy-oak-2-1d3087481f724e4612e801d5784db959.jpg";